<!--赖传峰-->
<!--2022/5/7-->
<template>
  <div
    ref="loadingElt"
    class="loading"
  />
</template>

<script
  lang="ts"
  setup
>
import lottie from 'lottie-web'
import {
  nextTick,
  onMounted,
  ref,
} from '#imports'

// eslint-disable-next-line no-spaced-func
const props = withDefaults(defineProps<{
  autoplay?: boolean;
  animationData: object | (() => Promise<object>);
}>(), { autoplay: false })

const loadingElt = ref<HTMLElement>()
const anim = ref<ReturnType<typeof lottie.loadAnimation>>()

onMounted(async () => {
  await nextTick()
  anim.value = lottie.loadAnimation({
    container: loadingElt.value!,
    renderer: 'svg',
    loop: true,
    autoplay: props.autoplay,
    animationData: typeof props.animationData === 'function' ? await props.animationData() : props.animationData,
  })
})

defineExpose({ getAnimationItem: () => anim.value })
</script>
